import React, { createContext, useContext, useEffect, useState } from "react";
interface BoardsContextType {
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  isDraggingDisable: boolean;
  setIsDraggingDisable: (value: boolean) => void;
  allObjectsInBoards: any[];
  setAllObjectsInBoards: React.Dispatch<React.SetStateAction<any[]>>;
}
const BoardsContext = createContext<BoardsContextType>({
  isDialogOpen: false,
  setIsDialogOpen: () => {},
  isDraggingDisable: false,
  setIsDraggingDisable: () => {},
  allObjectsInBoards: [],
  setAllObjectsInBoards: () => {},
});

export const BoardsProvider = ({ children }: { children: React.ReactNode }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDraggingDisable, setIsDraggingDisable] = useState(false);
  const [allObjectsInBoards, setAllObjectsInBoards] = useState<any[]>([]);

  useEffect(() => {
    console.log("isDraggingDisable", isDraggingDisable);
  }, [isDraggingDisable]);
  return (
    <BoardsContext.Provider
      value={{
        isDialogOpen,
        setIsDialogOpen,
        isDraggingDisable,
        setIsDraggingDisable,
        allObjectsInBoards,
        setAllObjectsInBoards,
      }}
    >
      {children}
    </BoardsContext.Provider>
  );
};

export const useBoardsContext = () => useContext(BoardsContext);
